var X = (t, r) => () => (r || t((r = { exports: {} }).exports, r), r.exports);
var We = X((be) => {
  (function (t) {
    var r = /\S/,
      e = /\"/g,
      s = /\n/g,
      l = /\r/g,
      f = /\\/g,
      m = /\u2028/,
      p = /\u2029/;
    t.tags = {
      "#": 1,
      "^": 2,
      "<": 3,
      $: 4,
      "/": 5,
      "!": 6,
      ">": 7,
      "=": 8,
      _v: 9,
      "{": 10,
      "&": 11,
      _t: 12,
    };
    t.scan = function n(i, c) {
      var E = i.length,
        D = 0,
        P = 1,
        K = 2,
        b = D,
        Q = null,
        ee = null,
        x = "",
        I = [],
        B = false,
        C = 0,
        te = 0,
        k = "{{",
        U = "}}";
      function Ne() {
        if (x.length > 0) {
          I.push({ tag: "_t", text: new String(x) });
          x = "";
        }
      }
      function et() {
        var O = true;
        for (var $ = te; $ < I.length; $++) {
          O =
            t.tags[I[$].tag] < t.tags["_v"] ||
            (I[$].tag == "_t" && I[$].text.match(r) === null);
          if (!O) {
            return false;
          }
        }
        return O;
      }
      function Pe(O, $) {
        Ne();
        if (O && et()) {
          for (var V = te, q; V < I.length; V++) {
            if (I[V].text) {
              if ((q = I[V + 1]) && q.tag == ">") {
                q.indent = I[V].text.toString();
              }
              I.splice(V, 1);
            }
          }
        } else if (!$) {
          I.push({ tag: "\n" });
        }
        B = false;
        te = I.length;
      }
      function tt(O, $) {
        var V = "=" + U,
          q = O.indexOf(V, $),
          re = A(O.substring(O.indexOf("=", $) + 1, q)).split(" ");
        k = re[0];
        U = re[re.length - 1];
        return q + V.length - 1;
      }
      if (c) {
        c = c.split(" ");
        k = c[0];
        U = c[1];
      }
      for (C = 0; C < E; C++) {
        if (b == D) {
          if (_(k, i, C)) {
            --C;
            Ne();
            b = P;
          } else {
            if (i.charAt(C) == "\n") {
              Pe(B);
            } else {
              x += i.charAt(C);
            }
          }
        } else if (b == P) {
          C += k.length - 1;
          ee = t.tags[i.charAt(C + 1)];
          Q = ee ? i.charAt(C + 1) : "_v";
          if (Q == "=") {
            C = tt(i, C);
            b = D;
          } else {
            if (ee) {
              C++;
            }
            b = K;
          }
          B = C;
        } else {
          if (_(U, i, C)) {
            I.push({
              tag: Q,
              n: A(x),
              otag: k,
              ctag: U,
              i: Q == "/" ? B - k.length : C + U.length,
            });
            x = "";
            C += U.length - 1;
            b = D;
            if (Q == "{") {
              if (U == "}}") {
                C++;
              } else {
                g(I[I.length - 1]);
              }
            }
          } else {
            x += i.charAt(C);
          }
        }
      }
      Pe(B, true);
      return I;
    };
    function g(n) {
      if (n.n.substr(n.n.length - 1) === "}") {
        n.n = n.n.substring(0, n.n.length - 1);
      }
    }
    function A(n) {
      if (n.trim) {
        return n.trim();
      }
      return n.replace(/^\s*|\s*$/g, "");
    }
    function _(n, i, c) {
      if (i.charAt(c) != n.charAt(0)) {
        return false;
      }
      for (var E = 1, D = n.length; E < D; E++) {
        if (i.charAt(c + E) != n.charAt(E)) {
          return false;
        }
      }
      return true;
    }
    var v = { _t: true, "\n": true, $: true, "/": true };
    function a(n, i, c, E) {
      var D = [],
        P = null,
        K = null,
        b = null;
      K = c[c.length - 1];
      while (n.length > 0) {
        b = n.shift();
        if (K && K.tag == "<" && !(b.tag in v)) {
          throw new Error("Illegal content in < super tag.");
        }
        if (t.tags[b.tag] <= t.tags["$"] || o(b, E)) {
          c.push(b);
          b.nodes = a(n, b.tag, c, E);
        } else if (b.tag == "/") {
          if (c.length === 0) {
            throw new Error("Closing tag without opener: /" + b.n);
          }
          P = c.pop();
          if (b.n != P.n && !d(b.n, P.n, E)) {
            throw new Error("Nesting error: " + P.n + " vs. " + b.n);
          }
          P.end = b.i;
          return D;
        } else if (b.tag == "\n") {
          b.last = n.length == 0 || n[0].tag == "\n";
        }
        D.push(b);
      }
      if (c.length > 0) {
        throw new Error("missing closing tag: " + c.pop().n);
      }
      return D;
    }
    function o(n, i) {
      for (var c = 0, E = i.length; c < E; c++) {
        if (i[c].o == n.n) {
          n.tag = "#";
          return true;
        }
      }
    }
    function d(n, i, c) {
      for (var E = 0, D = c.length; E < D; E++) {
        if (c[E].c == n && c[E].o == i) {
          return true;
        }
      }
    }
    function u(n) {
      var i = [];
      for (var c in n) {
        i.push('"' + y(c) + '": function(c,p,t,i) {' + n[c] + "}");
      }
      return "{ " + i.join(",") + " }";
    }
    function h(n) {
      var i = [];
      for (var c in n.partials) {
        i.push(
          '"' +
            y(c) +
            '":{name:"' +
            y(n.partials[c].name) +
            '", ' +
            h(n.partials[c]) +
            "}"
        );
      }
      return "partials: {" + i.join(",") + "}, subs: " + u(n.subs);
    }
    t.stringify = function (n, i, c) {
      return (
        "{code: function (c,p,i) { " + t.wrapMain(n.code) + " }," + h(n) + "}"
      );
    };
    var S = 0;
    t.generate = function (n, i, c) {
      S = 0;
      var E = { code: "", subs: {}, partials: {} };
      t.walk(n, E);
      if (c.asString) {
        return this.stringify(E, i, c);
      }
      return this.makeTemplate(E, i, c);
    };
    t.wrapMain = function (n) {
      return 'var t=this;t.b(i=i||"");' + n + "return t.fl();";
    };
    t.template = t.Template;
    t.makeTemplate = function (n, i, c) {
      var E = this.makePartials(n);
      E.code = new Function("c", "p", "i", this.wrapMain(n.code));
      return new this.template(E, i, this, c);
    };
    t.makePartials = function (n) {
      var i,
        c = { subs: {}, partials: n.partials, name: n.name };
      for (i in c.partials) {
        c.partials[i] = this.makePartials(c.partials[i]);
      }
      for (i in n.subs) {
        c.subs[i] = new Function("c", "p", "t", "i", n.subs[i]);
      }
      return c;
    };
    function y(n) {
      return n
        .replace(f, "\\\\")
        .replace(e, '\\"')
        .replace(s, "\\n")
        .replace(l, "\\r")
        .replace(m, "\\u2028")
        .replace(p, "\\u2029");
    }
    function R(n) {
      return ~n.indexOf(".") ? "d" : "f";
    }
    function T(n, i) {
      var c = "<" + (i.prefix || "");
      var E = c + n.n + S++;
      i.partials[E] = { name: n.n, partials: {} };
      i.code += 't.b(t.rp("' + y(E) + '",c,p,"' + (n.indent || "") + '"));';
      return E;
    }
    t.codegen = {
      "#": function (n, i) {
        i.code +=
          "if(t.s(t." +
          R(n.n) +
          '("' +
          y(n.n) +
          '",c,p,1),c,p,0,' +
          n.i +
          "," +
          n.end +
          ',"' +
          n.otag +
          " " +
          n.ctag +
          '")){t.rs(c,p,function(c,p,t){';
        t.walk(n.nodes, i);
        i.code += "});c.pop();}";
      },
      "^": function (n, i) {
        i.code +=
          "if(!t.s(t." + R(n.n) + '("' + y(n.n) + '",c,p,1),c,p,1,0,0,"")){';
        t.walk(n.nodes, i);
        i.code += "};";
      },
      ">": T,
      "<": function (n, i) {
        var c = { partials: {}, code: "", subs: {}, inPartial: true };
        t.walk(n.nodes, c);
        var E = i.partials[T(n, i)];
        E.subs = c.subs;
        E.partials = c.partials;
      },
      $: function (n, i) {
        var c = { subs: {}, code: "", partials: i.partials, prefix: n.n };
        t.walk(n.nodes, c);
        i.subs[n.n] = c.code;
        if (!i.inPartial) {
          i.code += 't.sub("' + y(n.n) + '",c,p,i);';
        }
      },
      "\n": function (n, i) {
        i.code += H('"\\n"' + (n.last ? "" : " + i"));
      },
      _v: function (n, i) {
        i.code += "t.b(t.v(t." + R(n.n) + '("' + y(n.n) + '",c,p,0)));';
      },
      _t: function (n, i) {
        i.code += H('"' + y(n.text) + '"');
      },
      "{": w,
      "&": w,
    };
    function w(n, i) {
      i.code += "t.b(t.t(t." + R(n.n) + '("' + y(n.n) + '",c,p,0)));';
    }
    function H(n) {
      return "t.b(" + n + ");";
    }
    t.walk = function (n, i) {
      var c;
      for (var E = 0, D = n.length; E < D; E++) {
        c = t.codegen[n[E].tag];
        c && c(n[E], i);
      }
      return i;
    };
    t.parse = function (n, i, c) {
      c = c || {};
      return a(n, "", [], c.sectionTags || []);
    };
    t.cache = {};
    t.cacheKey = function (n, i) {
      return [
        n,
        !!i.asString,
        !!i.disableLambda,
        i.delimiters,
        !!i.modelGet,
      ].join("||");
    };
    t.compile = function (n, i) {
      i = i || {};
      var c = t.cacheKey(n, i);
      var E = this.cache[c];
      if (E) {
        var D = E.partials;
        for (var P in D) {
          delete D[P].instance;
        }
        return E;
      }
      E = this.generate(this.parse(this.scan(n, i.delimiters), n, i), n, i);
      return (this.cache[c] = E);
    };
  })(typeof be !== "undefined" ? be : Hogan);
});
var Je = X((Re) => {
  var mt = {};
  (function (t) {
    t.Template = function (a, o, d, u) {
      a = a || {};
      this.r = a.code || this.r;
      this.c = d;
      this.options = u || {};
      this.text = o || "";
      this.partials = a.partials || {};
      this.subs = a.subs || {};
      this.buf = "";
    };
    t.Template.prototype = {
      r: function (a, o, d) {
        return "";
      },
      v: _,
      t: A,
      render: function a(o, d, u) {
        return this.ri([o], d || {}, u);
      },
      ri: function (a, o, d) {
        return this.r(a, o, d);
      },
      ep: function (a, o) {
        var d = this.partials[a];
        var u = o[d.name];
        if (d.instance && d.base == u) {
          return d.instance;
        }
        if (typeof u == "string") {
          if (!this.c) {
            throw new Error("No compiler available.");
          }
          u = this.c.compile(u, this.options);
        }
        if (!u) {
          return null;
        }
        this.partials[a].base = u;
        if (d.subs) {
          if (!o.stackText) o.stackText = {};
          for (key in d.subs) {
            if (!o.stackText[key]) {
              o.stackText[key] =
                this.activeSub !== void 0 && o.stackText[this.activeSub]
                  ? o.stackText[this.activeSub]
                  : this.text;
            }
          }
          u = e(
            u,
            d.subs,
            d.partials,
            this.stackSubs,
            this.stackPartials,
            o.stackText
          );
        }
        this.partials[a].instance = u;
        return u;
      },
      rp: function (a, o, d, u) {
        var h = this.ep(a, d);
        if (!h) {
          return "";
        }
        return h.ri(o, d, u);
      },
      rs: function (a, o, d) {
        var u = a[a.length - 1];
        if (!v(u)) {
          d(a, o, this);
          return;
        }
        for (var h = 0; h < u.length; h++) {
          a.push(u[h]);
          d(a, o, this);
          a.pop();
        }
      },
      s: function (a, o, d, u, h, S, y) {
        var R;
        if (v(a) && a.length === 0) {
          return false;
        }
        if (typeof a == "function") {
          a = this.ms(a, o, d, u, h, S, y);
        }
        R = !!a;
        if (!u && R && o) {
          o.push(typeof a == "object" ? a : o[o.length - 1]);
        }
        return R;
      },
      d: function (a, o, d, u) {
        var h,
          S = a.split("."),
          y = this.f(S[0], o, d, u),
          R = this.options.modelGet,
          T = null;
        if (a === "." && v(o[o.length - 2])) {
          y = o[o.length - 1];
        } else {
          for (var w = 1; w < S.length; w++) {
            h = r(S[w], y, R);
            if (h !== void 0) {
              T = y;
              y = h;
            } else {
              y = "";
            }
          }
        }
        if (u && !y) {
          return false;
        }
        if (!u && typeof y == "function") {
          o.push(T);
          y = this.mv(y, o, d);
          o.pop();
        }
        return y;
      },
      f: function (a, o, d, u) {
        var h = false,
          S = null,
          y = false,
          R = this.options.modelGet;
        for (var T = o.length - 1; T >= 0; T--) {
          S = o[T];
          h = r(a, S, R);
          if (h !== void 0) {
            y = true;
            break;
          }
        }
        if (!y) {
          return u ? false : "";
        }
        if (!u && typeof h == "function") {
          h = this.mv(h, o, d);
        }
        return h;
      },
      ls: function (a, o, d, u, h) {
        var S = this.options.delimiters;
        this.options.delimiters = h;
        this.b(this.ct(A(a.call(o, u)), o, d));
        this.options.delimiters = S;
        return false;
      },
      ct: function (a, o, d) {
        if (this.options.disableLambda) {
          throw new Error("Lambda features disabled.");
        }
        return this.c.compile(a, this.options).render(o, d);
      },
      b: function (a) {
        this.buf += a;
      },
      fl: function () {
        var a = this.buf;
        this.buf = "";
        return a;
      },
      ms: function (a, o, d, u, h, S, y) {
        var R,
          T = o[o.length - 1],
          w = a.call(T);
        if (typeof w == "function") {
          if (u) {
            return true;
          } else {
            R =
              this.activeSub && this.subsText && this.subsText[this.activeSub]
                ? this.subsText[this.activeSub]
                : this.text;
            return this.ls(w, T, d, R.substring(h, S), y);
          }
        }
        return w;
      },
      mv: function (a, o, d) {
        var u = o[o.length - 1];
        var h = a.call(u);
        if (typeof h == "function") {
          return this.ct(A(h.call(u)), u, d);
        }
        return h;
      },
      sub: function (a, o, d, u) {
        var h = this.subs[a];
        if (h) {
          this.activeSub = a;
          h(o, d, this, u);
          this.activeSub = false;
        }
      },
    };
    function r(a, o, d) {
      var u;
      if (o && typeof o == "object") {
        if (o[a] !== void 0) {
          u = o[a];
        } else if (d && o.get && typeof o.get == "function") {
          u = o.get(a);
        }
      }
      return u;
    }
    function e(a, o, d, u, h, S) {
      function y() {}
      y.prototype = a;
      function R() {}
      R.prototype = a.subs;
      var T;
      var w = new y();
      w.subs = new R();
      w.subsText = {};
      w.buf = "";
      u = u || {};
      w.stackSubs = u;
      w.subsText = S;
      for (T in o) {
        if (!u[T]) u[T] = o[T];
      }
      for (T in u) {
        w.subs[T] = u[T];
      }
      h = h || {};
      w.stackPartials = h;
      for (T in d) {
        if (!h[T]) h[T] = d[T];
      }
      for (T in h) {
        w.partials[T] = h[T];
      }
      return w;
    }
    var s = /&/g,
      l = /</g,
      f = />/g,
      m = /\'/g,
      p = /\"/g,
      g = /[&<>\"\']/;
    function A(a) {
      return String(a === null || a === void 0 ? "" : a);
    }
    function _(a) {
      a = A(a);
      return g.test(a)
        ? a
            .replace(s, "&amp;")
            .replace(l, "&lt;")
            .replace(f, "&gt;")
            .replace(m, "&#39;")
            .replace(p, "&quot;")
        : a;
    }
    var v =
      Array.isArray ||
      function (a) {
        return Object.prototype.toString.call(a) === "[object Array]";
      };
  })(typeof Re !== "undefined" ? Re : mt);
});
var ze = X((jt, je) => {
  var Z = We();
  Z.Template = Je().Template;
  Z.template = Z.Template;
  je.exports = Z;
});
var Ze = X((Ce) => {
  "use strict";
  Object.defineProperty(Ce, "__esModule", { value: true });
  Ce.formatMoney = Et;
  var gt = "${{amount}}";
  function Et(t, r) {
    if (typeof t === "string") {
      t = t.replace(".", "");
    }
    var e = "";
    var s = /\{\{\s*(\w+)\s*\}\}/;
    var l = r || gt;
    function f(m) {
      var p =
        arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
      var g =
        arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
      var A =
        arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
      if (isNaN(m) || m == null) {
        return 0;
      }
      m = (m / 100).toFixed(p);
      var _ = m.split(".");
      var v = _[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + g);
      var a = _[1] ? A + _[1] : "";
      return v + a;
    }
    switch (l.match(s)[1]) {
      case "amount":
        e = f(t, 2);
        break;
      case "amount_no_decimals":
        e = f(t, 0);
        break;
      case "amount_with_comma_separator":
        e = f(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        e = f(t, 0, ".", ",");
        break;
    }
    return l.replace(s, e);
  }
});
var F = "GraphQL Client";
var ne = 0;
var se = 3;
var ae =
  "An error occurred while fetching from the API. Review 'graphQLErrors' for details.";
var ie = "Response returned unexpected Content-Type:";
var oe =
  "An unknown error has occurred. The API did not return a data object or any errors in its response.";
var Y = { json: "application/json", multipart: "multipart/mixed" };
var ce = "X-SDK-Variant";
var ue = "X-SDK-Version";
var Le = "shopify-graphql-client";
var Oe = "0.10.4";
var W = 1e3;
var Ve = [429, 503];
var le = /@(defer)\b/i;
var $e = "\r\n";
var Me = /boundary="?([^=";]+)"?/i;
var fe = $e + $e;
function L(t, r = F) {
  return t.startsWith(`${r}`) ? t : `${r}: ${t}`;
}
function M(t) {
  return t instanceof Error ? t.message : JSON.stringify(t);
}
function he(t) {
  return t instanceof Error && t.cause ? t.cause : void 0;
}
function pe(t) {
  return t.flatMap(({ errors: r }) => {
    return r ?? [];
  });
}
function J({ client: t, retries: r }) {
  if (r !== void 0 && (typeof r !== "number" || r < ne || r > se)) {
    throw new Error(
      `${t}: The provided "retries" value (${r}) is invalid - it cannot be less than ${ne} or greater than ${se}`
    );
  }
}
function N(t, r) {
  return r &&
    (typeof r !== "object" ||
      Array.isArray(r) ||
      (typeof r === "object" && Object.keys(r).length > 0))
    ? { [t]: r }
    : {};
}
function de(t, r) {
  if (t.length === 0) {
    return r;
  }
  const e = t.pop();
  const s = { [e]: r };
  if (t.length === 0) {
    return s;
  }
  return de(t, s);
}
function Ue(t, r) {
  return Object.keys(r || {}).reduce(
    (e, s) => {
      if ((typeof r[s] === "object" || Array.isArray(r[s])) && t[s]) {
        e[s] = Ue(t[s], r[s]);
        return e;
      }
      e[s] = r[s];
      return e;
    },
    Array.isArray(t) ? [...t] : { ...t }
  );
}
function me([t, ...r]) {
  return r.reduce(Ue, { ...t });
}
function ge({
  clientLogger: t,
  customFetchApi: r = fetch,
  client: e = F,
  defaultRetryWaitTime: s = W,
  retriableCodes: l = Ve,
}) {
  const f = async (m, p, g) => {
    const A = p + 1;
    const _ = g + 1;
    let v;
    try {
      v = await r(...m);
      t({ type: "HTTP-Response", content: { requestParams: m, response: v } });
      if (!v.ok && l.includes(v.status) && A <= _) {
        throw new Error();
      }
      return v;
    } catch (a) {
      if (A <= _) {
        const o = v?.headers.get("Retry-After");
        await rt(o ? parseInt(o, 10) : s);
        t({
          type: "HTTP-Retry",
          content: {
            requestParams: m,
            lastResponse: v,
            retryAttempt: p,
            maxRetries: g,
          },
        });
        return f(m, A, g);
      }
      throw new Error(
        L(
          `${
            g > 0
              ? `Attempted maximum number of ${g} network retries. Last message - `
              : ""
          }${M(a)}`,
          e
        )
      );
    }
  };
  return f;
}
async function rt(t) {
  return new Promise((r) => setTimeout(r, t));
}
function Ee({
  headers: t,
  url: r,
  customFetchApi: e = fetch,
  retries: s = 0,
  logger: l,
}) {
  J({ client: F, retries: s });
  const f = { headers: t, url: r, retries: s };
  const m = nt(l);
  const p = ge({ customFetchApi: e, clientLogger: m, defaultRetryWaitTime: W });
  const g = st(p, f);
  const A = at(g);
  const _ = ht(g);
  return { config: f, fetch: g, request: A, requestStream: _ };
}
function nt(t) {
  return (r) => {
    if (t) {
      t(r);
    }
  };
}
async function xe(t) {
  const { errors: r, data: e, extensions: s } = await t.json();
  return {
    ...N("data", e),
    ...N("extensions", s),
    ...(r || !e
      ? {
          errors: {
            networkStatusCode: t.status,
            message: L(r ? ae : oe),
            ...N("graphQLErrors", r),
            response: t,
          },
        }
      : {}),
  };
}
function st(t, { url: r, headers: e, retries: s }) {
  return async (l, f = {}) => {
    const { variables: m, headers: p, url: g, retries: A } = f;
    const _ = JSON.stringify({ query: l, variables: m });
    J({ client: F, retries: A });
    const v = Object.entries({ ...e, ...p }).reduce((o, [d, u]) => {
      o[d] = Array.isArray(u) ? u.join(", ") : u.toString();
      return o;
    }, {});
    if (!v[ce] && !v[ue]) {
      v[ce] = Le;
      v[ue] = Oe;
    }
    const a = [g ?? r, { method: "POST", headers: v, body: _ }];
    return t(a, 1, A ?? s);
  };
}
function at(t) {
  return async (...r) => {
    if (le.test(r[0])) {
      throw new Error(
        L(
          "This operation will result in a streamable response - use requestStream() instead."
        )
      );
    }
    try {
      const e = await t(...r);
      const { status: s, statusText: l } = e;
      const f = e.headers.get("content-type") || "";
      if (!e.ok) {
        return { errors: { networkStatusCode: s, message: L(l), response: e } };
      }
      if (!f.includes(Y.json)) {
        return {
          errors: {
            networkStatusCode: s,
            message: L(`${ie} ${f}`),
            response: e,
          },
        };
      }
      return xe(e);
    } catch (e) {
      return { errors: { message: M(e) } };
    }
  };
}
async function* it(t) {
  const r = new TextDecoder();
  if (t.body[Symbol.asyncIterator]) {
    for await (const e of t.body) {
      yield r.decode(e);
    }
  } else {
    const e = t.body.getReader();
    let s;
    try {
      while (!(s = await e.read()).done) {
        yield r.decode(s.value);
      }
    } finally {
      e.cancel();
    }
  }
}
function ot(t, r) {
  return {
    async *[Symbol.asyncIterator]() {
      try {
        let e = "";
        for await (const s of t) {
          e += s;
          if (e.indexOf(r) > -1) {
            const l = e.lastIndexOf(r);
            const f = e.slice(0, l);
            const m = f
              .split(r)
              .filter((p) => p.trim().length > 0)
              .map((p) => {
                const g = p.slice(p.indexOf(fe) + fe.length).trim();
                return g;
              });
            if (m.length > 0) {
              yield m;
            }
            e = e.slice(l + r.length);
            if (e.trim() === `--`) {
              e = "";
            }
          }
        }
      } catch (e) {
        throw new Error(
          `Error occured while processing stream payload - ${M(e)}`
        );
      }
    },
  };
}
function ct(t) {
  return {
    async *[Symbol.asyncIterator]() {
      const r = await xe(t);
      yield { ...r, hasNext: false };
    },
  };
}
function ut(t) {
  return t
    .map((r) => {
      try {
        return JSON.parse(r);
      } catch (e) {
        throw new Error(`Error in parsing multipart response - ${M(e)}`);
      }
    })
    .map((r) => {
      const {
        data: e,
        incremental: s,
        hasNext: l,
        extensions: f,
        errors: m,
      } = r;
      if (!s) {
        return {
          data: e || {},
          ...N("errors", m),
          ...N("extensions", f),
          hasNext: l,
        };
      }
      const p = s.map(({ data: g, path: A, errors: _ }) => {
        return { data: g && A ? de(A, g) : {}, ...N("errors", _) };
      });
      return {
        data: p.length === 1 ? p[0].data : me([...p.map(({ data: g }) => g)]),
        ...N("errors", pe(p)),
        hasNext: l,
      };
    });
}
function lt(t, r) {
  if (t.length > 0) {
    throw new Error(ae, { cause: { graphQLErrors: t } });
  }
  if (Object.keys(r).length === 0) {
    throw new Error(oe);
  }
}
function ft(t, r) {
  const e = (r ?? "").match(Me);
  const s = `--${e ? e[1] : "-"}`;
  if (!t.body?.getReader && !t.body[Symbol.asyncIterator]) {
    throw new Error("API multipart response did not return an iterable body", {
      cause: t,
    });
  }
  const l = it(t);
  let f = {};
  let m;
  return {
    async *[Symbol.asyncIterator]() {
      try {
        let p = true;
        for await (const g of ot(l, s)) {
          const A = ut(g);
          m = A.find((v) => v.extensions)?.extensions ?? m;
          const _ = pe(A);
          f = me([f, ...A.map(({ data: v }) => v)]);
          p = A.slice(-1)[0].hasNext;
          lt(_, f);
          yield { ...N("data", f), ...N("extensions", m), hasNext: p };
        }
        if (p) {
          throw new Error(`Response stream terminated unexpectedly`);
        }
      } catch (p) {
        const g = he(p);
        yield {
          ...N("data", f),
          ...N("extensions", m),
          errors: {
            message: L(M(p)),
            networkStatusCode: t.status,
            ...N("graphQLErrors", g?.graphQLErrors),
            response: t,
          },
          hasNext: false,
        };
      }
    },
  };
}
function ht(t) {
  return async (...r) => {
    if (!le.test(r[0])) {
      throw new Error(
        L(
          "This operation does not result in a streamable response - use request() instead."
        )
      );
    }
    try {
      const e = await t(...r);
      const { statusText: s } = e;
      if (!e.ok) {
        throw new Error(s, { cause: e });
      }
      const l = e.headers.get("content-type") || "";
      switch (true) {
        case l.includes(Y.json):
          return ct(e);
        case l.includes(Y.multipart):
          return ft(e, l);
        default:
          throw new Error(`${ie} ${l}`, { cause: e });
      }
    } catch (e) {
      return {
        async *[Symbol.asyncIterator]() {
          const s = he(e);
          yield {
            errors: {
              message: L(M(e)),
              ...N("networkStatusCode", s?.status),
              ...N("response", s),
            },
            hasNext: false,
          };
        },
      };
    }
  };
}
function ye({ client: t, storeDomain: r }) {
  try {
    if (!r || typeof r !== "string") {
      throw new Error();
    }
    const e = r.trim();
    const s = e.match(/^https?:/) ? e : `https://${e}`;
    const l = new URL(s);
    l.protocol = "https";
    return l.origin;
  } catch (e) {
    throw new Error(`${t}: a valid store domain ("${r}") must be provided`);
  }
}
function j({
  client: t,
  currentSupportedApiVersions: r,
  apiVersion: e,
  logger: s,
}) {
  const l = `${t}: the provided apiVersion ("${e}")`;
  const f = `Currently supported API versions: ${r.join(", ")}`;
  if (!e || typeof e !== "string") {
    throw new Error(`${l} is invalid. ${f}`);
  }
  const m = e.trim();
  if (!r.includes(m)) {
    if (s) {
      s({
        type: "Unsupported_Api_Version",
        content: { apiVersion: e, supportedApiVersions: r },
      });
    } else {
      console.warn(`${l} is likely deprecated or not supported. ${f}`);
    }
  }
}
function z(t) {
  const r = t * 3 - 2;
  return r === 10 ? r : `0${r}`;
}
function Ae(t, r, e) {
  const s = r - e;
  if (s <= 0) {
    return `${t - 1}-${z(s + 4)}`;
  }
  return `${t}-${z(s)}`;
}
function Fe() {
  const t = new Date();
  const r = t.getUTCMonth();
  const e = t.getUTCFullYear();
  const s = Math.floor(r / 3 + 1);
  return { year: e, quarter: s, version: `${e}-${z(s)}` };
}
function _e() {
  const { year: t, quarter: r, version: e } = Fe();
  const s = r === 4 ? `${t + 1}-01` : `${t}-${z(r + 1)}`;
  return [Ae(t, r, 3), Ae(t, r, 2), Ae(t, r, 1), e, s, "unstable"];
}
function ve(t) {
  return (r) => {
    return { ...(r ?? {}), ...t.headers };
  };
}
function Te({ getHeaders: t, getApiUrl: r }) {
  return (e, s) => {
    const l = [e];
    if (s && Object.keys(s).length > 0) {
      const { variables: f, apiVersion: m, headers: p, retries: g } = s;
      l.push({
        ...(f ? { variables: f } : {}),
        ...(p ? { headers: t(p) } : {}),
        ...(m ? { url: r(m) } : {}),
        ...(g ? { retries: g } : {}),
      });
    }
    return l;
  };
}
var Se = "application/json";
var Ge = "storefront-api-client";
var ke = "0.3.4";
var qe = "X-Shopify-Storefront-Access-Token";
var Ke = "Shopify-Storefront-Private-Token";
var Qe = "X-SDK-Variant";
var Be = "X-SDK-Version";
var He = "X-SDK-Variant-Source";
var G = "Storefront API Client";
function Xe(t) {
  if (t && typeof window !== "undefined") {
    throw new Error(
      `${G}: private access tokens and headers should only be used in a server-to-server implementation. Use the public API access token in nonserver environments.`
    );
  }
}
function Ye(t, r) {
  if (!t && !r) {
    throw new Error(`${G}: a public or private access token must be provided`);
  }
  if (t && r) {
    throw new Error(
      `${G}: only provide either a public or private access token`
    );
  }
}
function we({
  storeDomain: t,
  apiVersion: r,
  publicAccessToken: e,
  privateAccessToken: s,
  clientName: l,
  retries: f = 0,
  customFetchApi: m,
  logger: p,
}) {
  const g = _e();
  const A = ye({ client: G, storeDomain: t });
  const _ = { client: G, currentSupportedApiVersions: g, logger: p };
  j({ ..._, apiVersion: r });
  Ye(e, s);
  Xe(s);
  const v = pt(A, r, _);
  const a = {
    storeDomain: A,
    apiVersion: r,
    ...(e ? { publicAccessToken: e } : { privateAccessToken: s }),
    headers: {
      "Content-Type": Se,
      Accept: Se,
      [Qe]: Ge,
      [Be]: ke,
      ...(l ? { [He]: l } : {}),
      ...(e ? { [qe]: e } : { [Ke]: s }),
    },
    apiUrl: v(),
    clientName: l,
  };
  const o = Ee({
    headers: a.headers,
    url: a.apiUrl,
    retries: f,
    customFetchApi: m,
    logger: p,
  });
  const d = ve(a);
  const u = dt(a, v);
  const h = Te({ getHeaders: d, getApiUrl: u });
  const S = {
    config: a,
    getHeaders: d,
    getApiUrl: u,
    fetch: (...y) => {
      return o.fetch(...h(...y));
    },
    request: (...y) => {
      return o.request(...h(...y));
    },
    requestStream: (...y) => {
      return o.requestStream(...h(...y));
    },
  };
  return Object.freeze(S);
}
function pt(t, r, e) {
  return (s) => {
    if (s) {
      j({ ...e, apiVersion: s });
    }
    const l = (s ?? r).trim();
    return `${t}/api/${l}/graphql.json`;
  };
}
function dt(t, r) {
  return (e) => {
    return e ? r(e) : t.apiUrl;
  };
}
var yt = ze();
var De = Ze();
var Ie = class extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector(".as-predicts-container");
    this.productPredictContainer = this.querySelector(".as-predicts-products");
    if (!this.container) return;
    this.init();
  }
  init() {
    this.getPredicts();
  }
  async getPredicts() {
    ScarabQueue.push(["availabilityZone", this.getCurrentSite()]);
    ScarabQueue.push([
      "recommend",
      {
        // logic: this.dataset.logic.replace(/_$/, `_${Math.round(Math.random() * 10)}`),
        // _1 means most popular, _2 means second most popular and so on.
        logic: this.dataset.logic.replace(/_$/, '_1'),
        containerId: this.container.id,
        limit: 5,
        success: this.onSuccess.bind(this),
      },
    ]);
  }
  getCurrentSite() {
    const r = {
      "elegoo-shop": "official",
      "elegoo-us": "us",
      "elegoo-uk": "uk",
      "elegoo-ca": "ca",
      "elegoo-australia": "au",
      "elegoo-jp": "jp",
      "elegoo-eu": "eu",
      "fastgrowth-elegoo": "dev",
    };
    const e = window.emarsysDataLayer.store;
    return r[e] || "official";
  }
  async getProductData(r) {
    let e = [];
    let s = [];
    try {
      e = await this.fetchProductData(r);
      const l = e.map((p) => p.handle);
      const f = l.map((p) => this.getCustomMetafields(p));
      const m = await Promise.all(f);
      s = e.map((p, g) => {
        const A = [];
        for (const _ in m[0]) {
          if (_ !== "customTags" && m[g][_]) {
            A.push(m[g][_].value);
          }
        }
        return { ...p, customTags: m[g].customTags, customLabels: A };
      });
      this.formatProductsJson = this.formatProductsData(s);
      if (this.formatProductsJson?.items?.length > 0) {
        this.showPredicts();
        this.renderPredicts(this.formatProductsJson);
      }
    } catch (l) {
      console.error("Error in fetchAndMergeProductData:", l);
    }
  }
  onSuccess(r, e) {
    const s = r.page.products;
    if (s.length > 0) {
      const l = s.map((f) => f.link);
      this.getProductData(l);
    }
  }
  formatProductsData(r) {
    return {
      items: r.map((e) => {
        const s = e.variants.find((h) => h.available);
        const l = s ? s.id : null;
        const f = Array.isArray(e.media) && e.media.length > 0;
        const m = f ? e.media[0] : null;
        const p = f && e.media.length > 1 ? e.media[1] : null;
        const g = e.options.find((h) => {
          const S = h.name.toLowerCase();
          return (
            S.includes("color") ||
            S.includes("colour") ||
            S.includes("couleur") ||
            S.includes("farbe")
          );
        });
        let A;
        if (g) {
          A = g.values.map((h, S) => {
            const y = e.variants.find((H) => H.options.includes(h));
            const R = this.getFormatValue(h);
            let T = "";
            let w = "";
            if (R.includes(".")) {
              T = R;
            } else {
              w = R;
            }
            return {
              optionValue: w,
              index: S,
              active: S === 0,
              optionImage: T,
              variantUrl: `${e.url}?variant=${y.id}`,
              variantImage: y.featured_image ? y.featured_image.src : "",
            };
          });
        } else {
          A = null;
        }
        let _ = 2;
        const v = e.available;
        const a = e.compare_at_price ? e.compare_at_price > e.price : false;
        if (!v) {
          _--;
        }
        if (a) {
          _--;
        }
        let o = null;
        if (_ > 0 && e.customTags) {
          o = JSON.parse(e.customTags.value).map((h) => ({ tag: h }));
          o = o.slice(0, _);
        }
        let d = null;
        if (e.customLabels && e.customLabels.length > 0) {
          d = e.customLabels.map((h) => ({ label: h }));
        }
        const u = {
          title: e.title,
          id: e.id.toString(),
          vendor: e.vendor,
          urlForVendor: `/collections/vendors?q=${encodeURIComponent(
            e.vendor
          )}`,
          handle: e.handle,
          available: e.available,
          quickAdd: { firstAvailableVariantId: l ? l.toString() : null },
          customTags: o,
          customLabels: d,
          isPreOrder: e.special_stock === 'PRE-ORDER',
          url: e.url,
          hasOnlyDefaultVariant: e.variants.length === 1,
          price: `${De.formatMoney(e.price, window.theme.moneyFormat)}`,
          comparedPrice: e.compare_at_price
            ? `${De.formatMoney(e.compare_at_price, window.theme.moneyFormat)}`
            : null,
          savedAmount: e.compare_at_price
            ? `${De.formatMoney(
                e.compare_at_price - e.price,
                window.theme.moneyFormat
              )}`
            : null,
          savedPercentage: e.compare_at_price
            ? `${(
                ((e.compare_at_price - e.price) / e.compare_at_price) *
                100
              ).toFixed(0)}%`
            : null,
          onSale:
            e.available && e.compare_at_price
              ? e.compare_at_price > e.price
              : false,
          priceVaries: e.price_varies,
          showHoverMedia: f && e.media.length > 1,
          featuredMediaUrl: m ? m.src : null,
          featuredMediaWidth: m ? m.width : 1024,
          featuredMediaHeight: m ? m.height : 1024,
          hoverMediaUrl: p ? p.src : null,
          hoverMediaWidth: p ? p.width : 1024,
          hoverMediaHeight: p ? p.height : 1024,
          colorOptions: A,
        };
        return u;
      }),
    };
  }
  async getCustomMetafields(r) {
    const e = this.dataset.labelsField.split(",");
    let s = "";
    e.forEach((_) => {
      if (!_) return;
      s += `
        ${_}: metafield(namespace: "custom", key: "${_}") {
          value
        }
      `;
    });
    const l = {
      "https://test-elegoo.myshopify.com": "6e7e7b7377685263c40b386712f9ea16",
      "https://www.elegoo.com": "ad9ba57360025d7ddd8bcbc58f24440a",
      "https://ca.elegoo.com": "a182bffed41aad4d95a37020f48552bf",
      "https://jp.elegoo.com": "404e5c82f921430fd066c3ff89e38620",
      "https://au.elegoo.com": "97a9f83a201418b08d8f83914dcbaf4f",
      "https://uk.elegoo.com": "8761b4d8a844d79e271cd04ed5fb6e70",
      "https://eu.elegoo.com": "91827dfa8bfefe0406ebe2a3d17e50ce",
      "https://us.elegoo.com": "e8549bd9ec41392c0602d5493f7d4af0",
    };
    const f = this.dataset.storeUrl;
    const m = we({
      storeDomain: f,
      apiVersion: "2023-10",
      publicAccessToken: l[f],
    });
    const p = `query {
      product(handle: "${r}") {
        customTags: metafield(namespace: "custom", key: "product_tags") {
          value
        }
        special_stock: metafield(namespace: "custom", key: "special_stock") {
          value
        }
        ${s}
      }
    }`;
    const { data: g, errors: A } = await m.request(p);
    if (A) {
      return { customTags: null, customLabels: null };
    } else {
      if (g && g.product) {
        return g.product;
      } else {
        return { customTags: null, customLabels: null };
      }
    }
  }
  getFormatValue(r) {
    const e = r.toLowerCase();
    this.$swatchDom = this.querySelector(".as-color-swatch");
    if (!this.$swatchDom) return e;
    const { colorNames: s, colorValues: l } = this.$swatchDom.dataset;
    if (!s || !l) return e;
    const f = s.split(",").map((g) => g.trim().toLowerCase());
    const m = l.split(",");
    const p = f.indexOf(e);
    return p !== -1 ? m[p] : e;
  }
  async fetchProductData(r) {
    const e = r.map((s) => {
      const l = `${s}.js`;
      return fetch(l).then((f) => {
        if (!f.ok) {
          throw new Error(`HTTP error! status: ${f.status}`);
        }
        return f.json();
      });
    });
    try {
      const s = await Promise.all(e);
      return s;
    } catch (s) {}
  }
  showPredicts() {
    this.style.display = "block";
  }
  renderPredicts(r) {
    const e = this.tpl2html(`${this.productPredictContainer.id}-template`, r);
    this.productPredictContainer.innerHTML = e;
  }
  tpl2html(r, e) {
    const s = document.querySelector(`#${r}`);
    if (!s) return;
    const l = s && yt.compile(s.innerHTML);
    const f = l && l.render(e);
    return f || "";
  }
};
if (!customElements.get("product-predict")) {
  customElements.define("product-predict", Ie);
}
